'use strict';
angular.module('resourceCenterRouterModule').config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider
            .state('front.resourcectrl.xjrb.resource', {
                url: '/resource?belong&fcode&nodename&change&parentfcode&parentbelong&ispic&imgflag',
                views: {
                    'resource@front.resourcectrl.xjrb': {
                        templateUrl: './resourceCenter/XJRB/xjrb_main_tpl.html',
                        controller: 'resCenterXJRBRelCtrl',
                    },
                },
            })
            .state('front.resourcectrl.xjrb.quickpreview', {
                url: '/quickpreview?fcode&nodename&media_id&change&guid&channeltype&theme',
                views: {
                    'resource@front.resourcectrl.xjrb': {
                        templateUrl: './resourceCenter/XJRB/quickPreview/main_tpl.html',
                        controller: 'XJRBQuickPreviewCtrl',
                    },
                },
            });
    },
]);
